<template>
    <card
        class="o-card-economy"
        modifier="economy"
        :bg="bg"
    >
        <template #inner>
            <asset
                class="o-card-economy__bg"
                :image="image"
            />

            <header class="o-card-economy__inner">
                <h3
                    v-if="title"
                    class="o-card-economy__title"
                >
                    {{ title }}
                </h3>

                <prismic-rich-text
                    class="o-card-economy__desc"
                    :field="desc"
                />

                <a
                    v-if="website"
                    :href="website.url"
                    :title="title"
                    class="o-card-economy__website"
                    target="_blank"
                    rel="noopener"
                >
                    {{ websiteName }}
                </a>

            </header>
        </template>
    </card>
</template>

<script>

import Asset from 'objects/Asset';
import PrismicRichText from 'objects/PrismicRichText';
import Card from 'components/Card';

export default {
    name: 'CardEconomy',
    components: {
        Asset,
        PrismicRichText,
        Card,
    },
    props: {
        bg: {
            type: String,
            default: null,
        },
        modifier: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            default: null,
        },
        desc: {
            type: Array,
        },
        website: {
            type: Object,
        },
        image: {
            type: Object,
        },
    },
    data: () => ({
        imageSize: 320,
    }),
    computed: {

        hasImage() {
            return !!(this.image && this.image.url)
        },

        imageRatio() {

            if(!this.hasImage) {
                return 0;
            }

            return this.image.dimensions.width/this.image.dimensions.height
        },


        srcset() {
            const img1 = `${this.image.url}?dpr=1`;
            const img2 = `${this.image.url}?dpr=2`;
            const img3 = `${this.image.url}?dpr=3`;
            return `${img1} ${this.imageSize}w, ${img2} ${this.imageSize * 2}w, ${img3} ${this.imageSize * 3}w`
        },

        websiteName() {
            if(!this.website) {
                return
            }

            return this.website.url.replace(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?/i, "").split('/')[0]
        },
    }
};
</script>

<style lang="scss">

.o-card-economy {

    &.-simple {

        .o-card-economy__bg {
            position: relative;
            height: auto;
            margin-bottom: 1.5em;

            img {
                height: auto;
                object-fit: initial;
                object-position: initial;
            }
        }

        .o-card-economy__inner {
            padding-bottom: var(--padding-content);
        }
    }

    &.-simple,
    &.-light {
        --color-text: #{$color-dark};

        .o-card-economy__title {
            color: $color-bright;
        }
    }
}

.o-card-economy__inner {
    padding: var(--padding-content) var(--padding-content) 100%;
}

.o-card-economy__bg {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    // overflow: hidden;

    // img {
    //     position: absolute;
    //     bottom: 0;
    //     left: 50%;
    //     display: block;
    //     width: auto;
    //     height: 100%;
    //     transform: translate(-50%, 0);
    // }

    img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: 50% 20%;
    }

    @media #{$breakpoint-horizontal} {

        img {
            object-position: 50% 100%;
        }
    }
}

.o-card-economy__title {
    font-family: ff("heading");
    font-size: 1.875em;
    font-weight: 400;
    margin-bottom: .5em;
}

.o-card-economy__website {
    display: inline-block;
    margin-top: 2em;

    &:before {
        @include pseudo-el($height: .1em, $bg: currentColor);
        position: absolute;
        bottom: -.25em;
        left: 0;
    }
}

</style>
